// src/app/services/socket.service.ts
import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SocketService {
  private socket: Socket;

  constructor() {
    this.socket = io('https://edufundapi.ta2ng.com', {
      transports: ['websocket'],
      secure: true,
    });
  }

  onTicketExpired(ticketId: string): Observable<{ status: string }> {
    return new Observable((observer) => {
      const eventName = `ticket-expired-${ticketId}`;
      const handler = (data: any) => observer.next(data);

      this.socket.on(eventName, handler);

      return () => this.socket.off(eventName, handler);
    });
  }

  onNewOrder(): Observable<any> {
    return new Observable((observer) => {
      const handler = (data: any) => observer.next(data);

      this.socket.on('new_order', handler);

      return () => this.socket.off('new_order', handler);
    });
  }
  private newOrderObservers: ((data: any) => void)[] = [];
  private isNewOrderGlobalListenerAttached = false;

  listenNewOrderGlobal() {
    if (this.isNewOrderGlobalListenerAttached) {
      return;
    }
    
    this.isNewOrderGlobalListenerAttached = true;
    this.socket.on('new_order', (data: any) => {
      this.newOrderObservers.forEach((cb) => cb(data));
    });
  }

  onNewOrderGlobal(callback: (data: any) => void) {
    this.newOrderObservers.push(callback);
  }

  removeNewOrderGlobalObserver(callback: (data: any) => void) {
    this.newOrderObservers = this.newOrderObservers.filter((cb) => cb !== callback);
  }
}
